import React, { Component } from "react";
import { connect } from "react-redux";
import { StyledPaymentStatusModalBody } from "../../../_components/styled/home/stylesHome";
import { withRouter } from "react-router-dom";
import { BILLING_AND_PAYMENT } from "../../../_utils/routes";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import {
  Button,
  Divider,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { withTranslation } from "react-i18next";

class TldrPaymentStatusModal extends Component {
  render() {
    const { show, onHide, title, status, type, t, error, subscription } =
      this.props;
    return (
      <Modal isOpen={show} onClose={onHide} isCentered size="sm">
        <ModalOverlay />
        <ModalContent>
          {title && (
            <>
              <ModalHeader p="4">
                <Text>{title}</Text>
              </ModalHeader>
            </>
          )}
          <ModalCloseButton />
          <ModalBody p="4">
            <StyledPaymentStatusModalBody status={status}>
              {status === "success" ? (
                <FaCheckCircle className="icon" />
              ) : status === "error" ? (
                <FaTimesCircle className="icon" />
              ) : null}

              {status === "success" ? (
                <Text className="title">
                  {type === "downgrade" &&
                    subscription.subscribedPlan.source === "braintree" &&
                    t("payment_status_modal.modal_title_success_downgrade_bt")}
                  {type === "downgrade" &&
                    subscription.subscribedPlan.source !== "braintree" &&
                    t("payment_status_modal.modal_title_success_downgrade")}
                  {type === "upgrade" &&
                    t("payment_status_modal.modal_title_success_upgrade")}
                </Text>
              ) : status === "error" ? (
                <Text className="title">
                  {t("payment_status_modal.modal_title_failed")}
                </Text>
              ) : null}

              {status === "success" ? (
                <Text mt="4" className="body-text">
                  {type === "downgrade" &&
                    subscription.subscribedPlan.source === "braintree" &&
                    t("payment_status_modal.modal_success_msg_downgrade_bt")}
                  {type === "downgrade" &&
                    subscription.subscribedPlan.source !== "braintree" &&
                    t("payment_status_modal.modal_success_msg_downgrade")}
                  {type === "upgrade" &&
                    t("payment_status_modal.modal_success_msg_upgrade")}
                </Text>
              ) : status === "error" ? (
                <>
                  <Text mt="4" className="body-text">
                    {error
                      ? error
                      : t("payment_status_modal.modal_error_msg_first")}
                  </Text>
                  <Text mt="2" className="body-text">
                    {t("payment_status_modal.modal_error_msg_second")}
                  </Text>
                </>
              ) : null}
            </StyledPaymentStatusModalBody>
          </ModalBody>
          <Divider my="0" />
          <ModalFooter px="4">
            {status === "success" ? (
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  this.props.history.replace(BILLING_AND_PAYMENT);
                }}
                colorScheme="primary"
                variant="solid"
                fontWeight="normal"
                p="3"
              >
                {t("payment_status_modal.modal_success_btn")}
              </Button>
            ) : status === "error" ? (
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  onHide();
                }}
                colorScheme="primary"
                variant="secondary"
                fontWeight="normal"
                p="3"
              >
                {t("payment_status_modal.modal_error_btn")}
              </Button>
            ) : null}
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  subscription: state.subscription,
});

const mapDispatchToProps = (dispatch) => ({});

export default withTranslation(["billing"])(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(TldrPaymentStatusModal))
);
